/**
 * CMCD `headers` transmission mode.
 *
 * @group CMCD
 *
 * @beta
 */
export const CMCD_HEADERS = 'headers';
//# sourceMappingURL=CMCD_HEADERS.js.map